import { useState, useEffect } from 'react';
import { RolesApi } from '@/api/clients/roles/roles.api';

export const useGetRole = (roleId) => {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRole = async () => {
    if (!roleId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await RolesApi.getRole(roleId);
      const nextRole = response.data.data?.role;
      setRole(nextRole);
      return nextRole;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || 'Failed to fetch role';
      setError(errorMessage);
      console.error('Error fetching role:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRole().catch(() => {});
  }, [roleId]);

  const refetch = () => fetchRole();

  return {
    role,
    loading,
    error,
    refetch,
  };
};
